<div class="availability-timeline" [attr.aria-label]="collectorName + ' daily timeline'">
  <div class="timeline-track">
    <span
      *ngFor="let minute of hourGrid"
      class="timeline-gridline"
      [class.major]="minute % 360 === 0"
      [style.left.%]="minuteToPercentage(minute)"
    ></span>
    <span
      class="selected-range"
      [style.left.%]="minuteToPercentage(selectedFromMinute)"
      [style.width.%]="minuteToPercentage(selectedToMinute) - minuteToPercentage(selectedFromMinute)"
      aria-hidden="true"
    ></span>
    <button
      *ngFor="let segment of displaySegments; trackBy: trackBySegment"
      type="button"
      class="timeline-segment"
      [class.state-free]="segment.state === 'free'"
      [class.state-busy]="segment.state === 'busy'"
      [class.state-unavailable]="segment.state === 'unavailable'"
      [class.selected]="isSelected(segment)"
      [style.left.%]="segmentLeft(segment)"
      [style.width.%]="segmentWidth(segment)"
      [matTooltip]="formatMinuteOfDay(segment.fromMinute) + '–' + formatMinuteOfDay(segment.toMinute)"
      [matTooltipDisabled]="segment.state === 'busy'"
      [attr.aria-label]="collectorName + ', ' + segment.state + ', ' + formatMinuteOfDay(segment.fromMinute) + ' to ' + formatMinuteOfDay(segment.toMinute)"
      (mouseenter)="onSegmentEnter(segment)"
      (mouseleave)="onSegmentLeave()"
      (focus)="onSegmentFocus(segment)"
      (blur)="onSegmentLeave()"
      (click)="onSegmentClick(segment)"
    >
      <span
        *ngIf="segment.state === 'busy' && segment.assignments.length > 1"
        class="assignment-count"
      >
        {{ segment.assignments.length }} events
      </span>
      <span *ngIf="segment.state !== 'busy'" class="segment-label">
        {{ formatMinuteOfDay(segment.fromMinute) }}–{{ formatMinuteOfDay(segment.toMinute) }}
      </span>
    </button>
  </div>
  <div class="timeline-labels" aria-hidden="true">
    <span *ngFor="let minute of hourLabels" [style.left.%]="minuteToPercentage(minute)">
      {{ formatMinuteOfDay(minute) }}
    </span>
  </div>

  <section
    *ngIf="currentDetails() as details"
    class="assignment-details"
    [attr.aria-label]="collectorName + ' assignment details'"
  >
    <div class="details-heading">
      <strong>{{ assignmentsLabel(details) }}</strong>
      <button
        *ngIf="pinnedSegment"
        type="button"
        class="details-close"
        aria-label="Close assignment details"
        (click)="closePinned($event)"
      >×</button>
    </div>
    <div *ngFor="let assignment of details.assignments" class="assignment-detail">
      <span>{{ assignment.game.label }}</span>
      <span>{{ assignment.eventCode }}</span>
      <span>{{ formatAssignmentTime(assignment.startsAt) }}–{{ formatAssignmentTime(assignment.endsAt) }}</span>
      <span *ngIf="assignment.displayStatus">{{ assignment.displayStatus }}</span>
    </div>
  </section>
</div>
